import { Color } from 'cesium';

/** White is the identity under the default HIGHLIGHT blend mode: textures stay untouched. */
export const IFC_COLOR_DEFAULT = Color.WHITE;
/** Same cyan as the selected damage polygon (COLOR_POLYGON_SELECTED). */
export const IFC_COLOR_SELECTED = Color.fromCssColorString('#00FFFF');
export const IFC_COLOR_HOVER = Color.fromCssColorString('#B3F0FF');
